var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FullHeightPage } from '@juvare/common-web-ui/FullHeightPage';
import { Box } from '@mui/material';
import React from 'react';
import { AppPaper } from './AppPaper';
/**
 * @deprecated
 */
export const Panel = (props) => {
    const { overlayComponent: OverlayComponent, children, contentWidth, contentPadding, header: Header } = props, rest = __rest(props, ["overlayComponent", "children", "contentWidth", "contentPadding", "header"]);
    return (React.createElement(FullHeightPage, Object.assign({}, rest),
        Header && Header,
        OverlayComponent && (React.createElement(AppPaper, { contentPadding: contentPadding, contentWidth: contentWidth }, OverlayComponent)),
        children && (React.createElement(Box, { sx: {
                display: OverlayComponent ? 'none' : undefined,
            } },
            React.createElement(AppPaper, { contentPadding: contentPadding, contentWidth: contentWidth }, children)))));
};
